

import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import DisplayDateTime from '../Common/DisplayDateTime';
import store from '../../stores';
import { Offcanvas } from 'react-bootstrap';
import Activepieces from '../Workflows/Activepieces';
import BuilderHeader from '../Workflows/BuilderHeader';

const WorkflowsTab = (props) => {
  
  const [showBuilder, setShowBuilder] = useState(false);
  const [workflowExecution, setWorkflowExecution] = useState();
  const [, setBuilderView] = useState();
  const [builderDrawerClass, setBuilderDrawerClass] = useState('offcanvas-fullscreen');

  const handleClose = () => {
    setShowBuilder(false);
  }

  const handleShowBuilder = async (view, workflowExecution) => {
    
    //setBuilderDrawerClass(view !== "builder" ? "offcanvas-halfscreen" : "offcanvas-fullscreen");
    setBuilderDrawerClass("offcanvas-fullscreen");

    setWorkflowExecution(workflowExecution);
    setBuilderView(view);    
    setShowBuilder(true);

  }


  return (
    <>
    {props.request?.workflowExecutions && props.request.workflowExecutions.length > 0 ? (
      <>
        <Table>
          <thead>
            <tr>
              <th>Workflow</th>
              <th className="text-center">Status</th>
              <th className="text-center">Start Time</th>
              <th className="text-center">Duration</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
          {props.request.workflowExecutions.map((execution) => (                      
            <tr key={`run_${execution.run.runId}`}>
              <td>{execution.workflow.name}</td>
              {/*<td className="text-center">{workflow.isPerEnvironment ? (<i className="ti ti-circle-check"></i>):(<i className="ti ti-circle"></i>)}</td>*/}
              <td className="text-center">{execution.run.status}</td>                      
              <td className="text-center"><DisplayDateTime timestamp={execution.run.startTime} timezone={store.SessionStore.user.timezone} /></td>  
              <td className="text-center">{execution.run.duration}</td>
              <td className="text-center">
                <button type="button" className="btn p-0" onClick={()=>handleShowBuilder("run", execution)} ><i className="ti ti-zoom-in"></i></button>
              </td>
            </tr>    
            ))}          
          </tbody>
        </Table>
        </>
      ):(
        <div className="alert alert-secondary" role="alert">
          No workflows were executed by this request.
        </div>
      )}


  {workflowExecution &&
            <>
            <Offcanvas show={showBuilder} onHide={handleClose} placement="end" className={builderDrawerClass}>
              <Offcanvas.Body>
              <BuilderHeader {...props} workflow={workflowExecution.workflow} close={handleClose} setShowBuilder={setShowBuilder} />
                <Activepieces {...props} 
                              workflowExecution={workflowExecution} 
                              closeDrawer={handleClose}
                              view="run"
                              handleShowBuilder={handleShowBuilder}  />
              </Offcanvas.Body>
            </Offcanvas>
          </>
  }


      </>
  );
}

export default WorkflowsTab;

